/**
 * Fatura kalemlerinde kullanılan sayısal giriş alanı.
 *
 * Metni kendi içinde tutmaz; kalem modelindeki display alanından okur. Bu sayede
 * alan tamamen boşaltılabilir ve otomatik "0" yazılmaz. Sayıya çevirme odak
 * çıkışında veya Enter ile yapılır.
 */

import React from 'react';
import { TextField, Typography } from '@mui/material';

interface InvoiceNumberFieldProps {
  /** Ekranda görünen metin (boş olabilir). */
  text: string;
  onTextChange: (raw: string) => void;
  /** Odak çıkışı / Enter — metni sayıya çevirme zamanı. */
  onCommit: () => void;
  /** Birim veya para simgesi (₺, % gibi). */
  suffix?: string;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  /** Kaydetme denendiğinde boş kalan zorunlu alanları kırmızı gösterir. */
  invalid?: boolean;
  disabled?: boolean;
  width?: number | string;
  /** Hücre vurgusu gibi ek biçimler (örn. bgcolor). */
  sx?: Record<string, unknown>;
}

export const InvoiceNumberField: React.FC<InvoiceNumberFieldProps> = ({
  text,
  onTextChange,
  onCommit,
  suffix,
  label,
  placeholder,
  size = 'small',
  invalid,
  disabled,
  width,
  sx,
}) => (
  <TextField
    size={size}
    label={label}
    value={text}
    placeholder={placeholder}
    error={invalid}
    disabled={disabled}
    onChange={(e) => onTextChange(e.target.value)}
    onFocus={(e) => e.target.select()}
    onBlur={onCommit}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        (e.target as HTMLInputElement).blur();
      }
    }}
    inputMode="decimal"
    InputProps={{
      endAdornment: suffix ? (
        <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary', pl: 0.5 }}>
          {suffix}
        </Typography>
      ) : undefined,
    }}
    sx={{
      width: width ?? '100%',
      '& input': {
        textAlign: 'right',
        fontSize: '0.85rem',
        fontVariantNumeric: 'tabular-nums',
      },
      ...sx,
    }}
  />
);
